<template>
  <div class="ceramic texture-bg-css absolute pin-x pin-y">
    <div class="">
      <div class="w-full t-content">
        <div v-if="uuid" class="text-left t-conditions">
          <CeramicsModal
            :data="ceramicData"
            :uuid="uuid"
            :pageFullScreen="true"
          ></CeramicsModal>
        </div>
        <div v-else class="text-center t-conditions">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import CeramicsModal from '@/components/ceramics/CeramicsModal'

export default {
  name: 'ceramicDetail',
  components: {
    CeramicsModal
  },
  data() {
    return {
      ceramicData: null
    }
  },
  computed: {
    uuid() {
      return this.$route.params.ceramicUuid
    }
  },
  mounted: function() {
    this.ceramicData = { id: this.$route.params.ceramicUuid }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
</style>
